import React from 'react';
import Icon from '@ant-design/icons';

export const UserIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.6665 6.66634C6.6665 4.82539 8.15889 3.33301 9.99984 3.33301C11.8408 3.33301 13.3332 4.82539 13.3332 6.66634C13.3332 8.50729 11.8408 9.99967 9.99984 9.99967C8.15889 9.99967 6.6665 8.50729 6.6665 6.66634Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.19097 11.8512C7.03794 11.7384 6.8566 11.6659 6.6665 11.6659C5.28579 11.6659 4.1665 12.7852 4.1665 14.1659C4.1665 15.5466 5.28579 16.6659 6.6665 16.6659H13.3332C14.7139 16.6659 15.8332 15.5466 15.8332 14.1659C15.8332 12.7852 14.7139 11.6659 13.3332 11.6659C13.1431 11.6659 12.9617 11.7384 12.8087 11.8512C12.2559 12.2586 11.5726 12.4994 10.8332 12.4994H9.16651C8.42705 12.4994 7.74382 12.2586 7.19097 11.8512Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UserIconANT = (props: any) => <Icon component={UserIcon} {...props} />;
